import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";

// Import your reducers
import UserInfoReducer from "./auth";
import TeamWorkReducer from "../Components/Setting/Teamworks/store/TeamWorkReducer";
import SideBarReducer from "../Components/ProjectPanel/SideBar/SM/reducer";
import DashboardReducer from "../Components/Overview/Dashboard/store/Reducer";
import TechnicalDocsReducer from "../Components/DocumentManagement/DocumentPreparation/store/TechnicalDocsReducer";
import TransmittalReducer from "../Components/DocumentManagement/Transmittal/store/TransmittalReducer";
import CommentSheetReducer from "../Components/DocumentManagement/CommentSheet/store/CommentSheetReducer";
import TqReducer from "../Components/DocumentManagement/TQ/store/TqReducer";
import NcrReducer from "../Components/DocumentManagement/NCR/store/NcrReducer";
import PurchaseRequestReducer from "../Components/ProcurementManagement/PurchaseRequest/Store/PurchaseRequestReducer";
import RFPReducer from "../Components/ProcurementManagement/RFP/store/RFPReducer";
import OpReducer from "../Components/OperationManagement/OperationList/reducer/OpReducer";
import PowerBiReducer from "../Components/PowerBi/reducer";
import InboxReducer from "../Components/ProjectPanel/header/Inbox/reducer";
import ErrorsReducer from "../utils/ErrorPages/errorHandlerReducer";
import NsReducer from "../Components/ProjectPanel/header/UserProfile/reducer";
import CompanyReducer from "../Components/Home/store/ComopanyReducer"; // Fixed typo

// Company persist config with sessionStorage
const companyPersistConfig = {
  key: "company",
  storage: sessionStorage, // Persist in sessionStorage
};

// Wrap company reducer with persistReducer
const persistedCompanyReducer = persistReducer(
  companyPersistConfig,
  CompanyReducer
);

// Combine all reducers
const rootReducer = combineReducers({
  errorhandler: ErrorsReducer,
  auth: UserInfoReducer,
  company: persistedCompanyReducer, // Use persisted company reducer
  tmw: TeamWorkReducer,
  sidebar: SideBarReducer,
  dashboard: DashboardReducer,
  doc: TechnicalDocsReducer,
  trs: TransmittalReducer,
  commentSheet: CommentSheetReducer,
  tq: TqReducer,
  ncr: NcrReducer,
  pr: PurchaseRequestReducer,
  rfp: RFPReducer,
  op: OpReducer,
  powerBi: PowerBiReducer,
  inbox: InboxReducer,
  ns: NsReducer,
});

export default rootReducer;
